import Root from './root.js';

export default Root;